package com.essntl.uikit.components.image

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import com.essntl.core.network.ImageClient
import com.essntl.uikit.components.svg.loadSvgPainterFromBytes
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.koin.compose.koinInject

@Composable
fun AsyncUrlIcon(
    url: String,
    placeholder: @Composable BoxScope.() -> Unit = {},
    error: @Composable BoxScope.() -> Unit = {},
    contentDescription: String? = null,
    modifier: Modifier = Modifier,
    tint: Color = LocalContentColor.current,
) {
    val imageClient = koinInject<ImageClient>()

    key(url) {
        AsyncIcon(
            load = {
                imageClient.get(url)
            },
            painterFor = {
                loadSvgPainterFromBytes(it)
            },
            placeholder = placeholder,
            error = error,
            contentDescription = contentDescription,
            modifier = modifier,
            tint = tint,
        )
    }
}

@Composable
private fun <T> AsyncIcon(
    load: suspend () -> T,
    painterFor: @Composable (T) -> Painter,
    placeholder: @Composable BoxScope.() -> Unit = {},
    error: @Composable BoxScope.() -> Unit = {},
    contentDescription: String? = null,
    modifier: Modifier = Modifier,
    tint: Color = LocalContentColor.current,
) {
    var isLoading by remember {
        mutableStateOf(false)
    }

    var isFailure by remember {
        mutableStateOf(false)
    }

    var image: T? by remember {
        mutableStateOf(null)
    }

    LaunchedEffect(Unit) {
        launch {
            image =
                try {
                    isLoading = true
                    load()
                } catch (e: CancellationException) {
                    // ignore cancellation exception, it happens when the composable is disposed
                    null
                } catch (e: Exception) {
                    e.printStackTrace()
                    // instead of printing to console, you can also write this to log,
                    // or show some error placeholder
                    isFailure = true
                    null
                } finally {
                    isLoading = false
                }
        }
    }

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier,
    ) {
        if (image != null) {
            image?.let {
                Icon(
                    painter = painterFor(it),
                    contentDescription = contentDescription,
                    modifier = Modifier.matchParentSize(),
                    tint = tint,
                )
            }
        } else if (isFailure) {
            error()
        } else {
            placeholder()
        }
    }
}